<template>
    <div class="card bg-light mb-3">
        <div class="card-header">
            <h5 class="card-title">
                <i class="fa fa-th-list"></i>
                {{ $t('CHANNEL_SETTINGS_SHARED_MOVE_INSTANCE') }}:
            </h5>
        </div>

        <div class="card-body">
            <loading :active.sync="loading" :is-full-page="false"></loading>


            <div class="form-group">
                <label for="instanceSelection">{{ $t('INSTANCE_CREATE_SHARED_SELECT_INSTANCE') }}</label>
                <v-select label="title"
                          id="instanceSelection"
                          :options="availableInstances"
                          :searchable="true"
                          v-model="selectedInstance"
                          :reduce="instance => instance.id"
                          v-if="availableInstances"></v-select>
            </div>

            <div class="form-group" v-if="availableChannels && selectedInstance !== null">
                <label for="channelSelection">{{ $t('INSTANCE_CREATE_SHARED_TARGET_CHANNEL') }}</label>
                <v-select label="title"
                          id="channelSelection"
                          :options="availableChannels"
                          :searchable="true"
                          v-model="selectedChannel"
                          :reduce="channel => channel.chid"></v-select>
            </div>

            <div class="form-group" v-if="selectedInstance !== null && selectedChannel !== null">
                <button class="btn btn-primary"  @click="moveInstance">
                    {{ $t('INSTANCE_CREATE_SHARED_MOVE_BUTTON') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import Loading from 'vue-loading-overlay';

import { RepositoryFactory } from '../../../../../repositories/RepositoryFactory';

const ChannelRepository = RepositoryFactory.get('adminChannels');
const InstanceRepository = RepositoryFactory.get('instances');

export default {
  name: 'SharedChannelMoveInstanceSettings',
  components: { Loading },
  data() {
    return {
      loading: true,
      availableInstances: null,
      selectedInstance: null,
      availableChannels: null,
      selectedChannel: null,
    };
  },
  async mounted() {
    await this.fetchInstances()
      .then(() => this.fetchChannels())
      .then(() => this.loading = false);
  },
  methods: {
    async fetchChannels() {
      await ChannelRepository.getAll()
        .then((response) => {
          this.availableChannels = response.data.list;
        })
        .catch((error) => {
        });
    },
    async fetchInstances() {
      await InstanceRepository.getAll()
        .then((response) => {
          this.availableInstances = response.data.list;
        })
        .catch((error) => {
        });
    },
    async moveInstance() {
      if (this.selectedChannel === null || this.selectedInstance === null) { return false; }

      this.loading = true;
      await InstanceRepository.move({
	              instanceId: this.selectedInstance,
	              targetChannelId: this.selectedChannel,
      }).then((res) => {
              	this.$snotify.info(this.$t('INSTANCE_CREATE_SHARED_MOVED'));
              	this.selectedInstance = null;
        this.selectedChannel = null;
      }).finally(() => this.loading = false);
    },
  },
  computed: {
    settings() {
      return this.$store.getters.getChannelSettings;
    },
  },
};
</script>

<style scoped>

</style>
